import { Component, OnInit, ViewChild, inject } from '@angular/core';
import { TranslateService, TranslatePipe } from '@ngx-translate/core';
import { marker as _ } from '@biesbjerg/ngx-translate-extract-marker';
import { HttpErrorResponse } from '@angular/common/http';
import { AppModelModalComponent } from '@nimmsta/ng-commons-lib/forms';
import {
  Column,
  CustomAction,
  DataTableComponent,
  NimmstaDataSource,
  EmptyTableComponent,
} from '@nimmsta/ng-commons-lib/data-table';
import { StatusBadgePipe } from '@nimmsta/ng-commons-lib/pipes';
import { User } from '@nimmsta/ng-commons-lib/models';
import { ErrorComponent } from '@nimmsta/ng-commons-lib/error';
import { UserFormComponent } from '../user/user-form.component';
import { ActivatedRoute } from '@angular/router';
import { OrganizationSecondaryUserService } from '../../services/organization-secondary-user.service';

_('user.title');
@Component({
  selector: 'app-organization-secondary-user',
  templateUrl: 'organization-secondary-user.component.html',
  imports: [
    UserFormComponent,
    TranslatePipe,
    DataTableComponent,
    EmptyTableComponent,
    AppModelModalComponent,
    ErrorComponent,
  ],
  providers: [StatusBadgePipe],
})
export class OrganizationSecondaryUserComponent implements OnInit {
  private userService = inject(OrganizationSecondaryUserService);
  private translate = inject(TranslateService);
  private route = inject(ActivatedRoute);

  userSource!: NimmstaDataSource<User>;

  @ViewChild(DataTableComponent, { static: true })
  private tableComponent!: DataTableComponent<User>;

  @ViewChild('EditModal', { static: false })
  private editModalComponent!: AppModelModalComponent<User>;

  @ViewChild(UserFormComponent, { static: true })
  private userFormComponent!: UserFormComponent;

  customActions: CustomAction<User>[] = [];

  error?: HttpErrorResponse;

  get columns(): Column[] {
    return [
      new Column('family_name', 'user.family_name', { sortable: true }),
      new Column('given_name', 'user.given_name', { sortable: true }),
      new Column('email', 'user.email', { sortable: true }),
    ];
  }

  ngOnInit(): void {
    const orgId = this.route.snapshot.paramMap.get('id');
    if (!orgId) {
      throw new Error('Organization id is required');
    }
    this.userService.setOrgId(orgId);
    this.userSource = new NimmstaDataSource<User>(this.userService);
    const removeAction = new CustomAction('user.secondary-user.remove');
    removeAction.subscribe((id) => this.removeSecondaryOrg(id));
    this.customActions.push(removeAction);
  }

  openModal(title: string, editable: boolean, user: User): void {
    this.userFormComponent.editable = editable;
    this.userFormComponent.setValue(user);
    this.editModalComponent.title = title;
    this.editModalComponent.editable = editable;
    this.editModalComponent.show('sm');
  }

  onModalClose(): void {
    this.editModalComponent.hide();
    this.tableComponent.loadDataPage();
  }

  onSave(): void {
    this.userFormComponent.onSave();
  }

  removeSecondaryOrg(id: string): void {
    this.userService.removeSecondaryOrg(id).subscribe({
      next: () => {
        this.tableComponent.loadDataPage();
      },
      error: (error) => {
        this.error = error;
      },
    });
  }

  getSelectedObject(id: string): User | undefined {
    return this.userSource.data?.content.filter((d) => id === d.id).pop();
  }

  onLoading(loading: boolean): void {
    this.editModalComponent.loading = loading;
  }
}
